import { Brand, createBranded } from '@deltasierra/type-utilities';

export type AppAccessTokenId = Brand<number, 'AppAccessTokenId'>;
export const AppAccessTokenId = createBranded<AppAccessTokenId>();
